export default __webpack_public_path__ + "static/media/MobileImageItemEn1.a692dc8d.png";